<template>
    <button
        class="font-bold py-3 mt-8 rounded-full"
        :class="selected ? ' bg-primary-lighter text-primary cursor-default' : 'bg-primary text-white'"
        :disabled="selected"
    >
        <span v-if="selected">
            <font-awesome-icon :icon="['fas', 'check']"></font-awesome-icon> Current Plan
        </span>
        <span v-else>
            Choose Plan
        </span>
    </button>
</template>

<script>
export default {
    props: {
        selected: {
            type: Boolean,
            required: false,
        },
    },
}
</script>